<vflow
	[nodes]="nodes()"
	[edges]="edges()"
	(onComponentNodeEvent)="handleComponentEvent($event)"
/>
